import { DEFAULT_RAZORPAY_KEY, createPaidOrderSafe, loadSiteSettings } from './compat.js';

export function loadRazorpay() {
  return new Promise((resolve, reject) => {
    if (window.Razorpay) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = resolve;
    script.onerror = () => reject(new Error('Unable to load Razorpay checkout.'));
    document.head.appendChild(script);
  });
}

export async function startRazorpayPayment({ cart, delivery, draft, onSuccess, onFailure }) {
  await loadRazorpay();

  let razorpayKey = DEFAULT_RAZORPAY_KEY;
  try {
    const settings = await loadSiteSettings();
    razorpayKey = String(settings.razorpayKey || '').trim() || DEFAULT_RAZORPAY_KEY;
  } catch {
    razorpayKey = DEFAULT_RAZORPAY_KEY;
  }
  const amount = (cart || []).reduce((sum, item) => sum + Number(item.price || 0) * Number(item.qty || 1), 0);
  const options = {
    key: razorpayKey,
    amount: amount * 100,
    currency: 'INR',
    name: 'Muppadai Training Academy',
    description: `${cart.length} book(s)`,
    prefill: {
      name: delivery.name || '',
      contact: delivery.phone || '',
      email: delivery.email || ''
    },
    notes: {
      phone: delivery.phone || '',
      checkoutDraftId: draft?.id || '',
      books: cart.map((item) => `${item.bt} - ${item.vn} x${item.qty}`).join(' | ')
    },
    handler: async (response) => {
      const paymentId = response.razorpay_payment_id;
      try {
        const order = await createPaidOrderSafe({
          paymentId,
          cart,
          delivery,
          draftId: draft?.id || ''
        });
        onSuccess?.(order);
      } catch (error) {
        onFailure?.((error?.message || 'Payment received, but order sync is pending.') + ` Payment ID: ${paymentId}`);
      }
    },
    modal: {
      ondismiss: () => onFailure?.('Payment window closed.')
    }
  };
  const checkout = new window.Razorpay(options);
  checkout.on('payment.failed', (response) => onFailure?.(response?.error?.description || 'Payment failed.'));
  checkout.open();
}
